import dynamic from 'next/dynamic';
import PropTypes from 'prop-types';

import OfferGridCard from 'components/Timeline/OfferCard/V2/OfferGridCard/Card';

import CarouselHeading from './CarouselHeading';

const CarouselBox = dynamic(() => import('components/CarouselBox'), {
  ssr: true,
});

const SHOW_ARROWS_THRESHOLD = 4;

const OffersShowcaseCarousel = ({
  gaEventCategory,
  subtitle,
  title,
  offers,
}) => {
  if (offers.length === 0) {
    return null;
  }

  return (
    <section className="rounded-4 bg-[radial-gradient(rgba(24,25,25,1)_0%,_rgba(21,70,120,1)_100%)] p-3 dark:bg-primary-500">
      <CarouselBox
        HeadingComponent={(props) => (
          <CarouselHeading
            showArrows={offers.length > SHOW_ARROWS_THRESHOLD}
            subtitle={subtitle}
            title={title}
            {...props}
          />
        )}
        carouselProps={{ className: 'pl-2 pb-3' }}
        dotsProps={{ className: 'xl:hidden' }}
        itemProps={{
          itemSize: 95,
          slidesPerView: 1,
          breakpoints: {
            md: { slidesPerView: 2, itemSize: 90 },
            lg: { slidesPerView: 3, itemSize: 95 },
            xl: { slidesPerView: 4, itemSize: 95 },
          },
        }}
        list={offers}
        offsetX={{ left: '-left-4', right: '-right-4' }}
        render={(offer, index) => (
          <OfferGridCard
            key={`${offer.key}-${index}`}
            authors={offer.authors}
            className="bg-neutral-high-100"
            gaEventCategory={gaEventCategory}
            offerComments={offer.comments}
            offerId={offer.id}
            offerLikes={offer.likes}
            offerOldPrice={offer.oldPrice}
            offerPhoto={offer.photo}
            offerPrice={offer.price}
            offerPriceType={offer.priceType}
            offerPublished={offer.published}
            offerSlug={offer.slug}
            offerStatusName={offer.statusName}
            offerTags={offer.tags}
            offerTitle={offer.title}
            storeDomain={offer.store.domain}
            userId={offer.user.id}
            userName={offer.user.name}
            userPhoto={offer.user.photo}
            isOffersShowcaseCard
          />
        )}
        dots
        full
      />
    </section>
  );
};

OffersShowcaseCarousel.propTypes = {
  gaEventCategory: PropTypes.string.isRequired,
  offers: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  subtitle: PropTypes.string,
  title: PropTypes.string,
};

export default OffersShowcaseCarousel;
